import { useMemo } from 'react';
import dayjs from 'dayjs';

import {
  isUserActionNeedLivenessVerification,
  LivenessAction,
  useApplicationState,
} from '@atlas/core';

/**
 * Custom hook to determine if face verification is needed
 * @returns {object} Object containing isNeedFaceCheck boolean and related account data
 */
export const useFaceCheck = () => {
  const applicationState = useApplicationState();
  const { account } = applicationState;

  const { docNumber, livenessVerificationDate } = account;

  const isNeedFaceCheck = useMemo(() => {
    if (!docNumber) {
      return false;
    }

    const daysThreshold = 1;
    const isLivenessExpired =
      !livenessVerificationDate ||
      dayjs(livenessVerificationDate).add(daysThreshold, 'days').valueOf() < dayjs().valueOf();

    const isActionNeedLiveness = isUserActionNeedLivenessVerification(
      account,
      LivenessAction.WITHDRAWAL,
    );

    return isLivenessExpired && isActionNeedLiveness;
  }, [docNumber, livenessVerificationDate, account]);

  return {
    account,
    docNumber,
    isNeedFaceCheck,
    livenessVerificationDate,
  };
};
